module.exports = __webpack_public_path__ + "media/arrow-up-disabled.f56f74e7.svg";